export default function AlertBanner() {
  const alertText = "Rider Alerts: Direct Airport Shuttle is here!";

  return (
    <div className="w-full bg-accent-500 overflow-hidden py-2.5">
      <div className="flex animate-marquee whitespace-nowrap">
        <span className="flex items-center gap-12 px-6">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="flex items-center gap-2 text-sm font-medium text-background-50">
              <strong>{alertText}</strong>
            </span>
          ))}
        </span>
        <span className="flex items-center gap-12 px-6" aria-hidden="true">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="flex items-center gap-2 text-sm font-medium text-background-50">
              <strong>{alertText}</strong>
            </span>
          ))}
        </span>
      </div>
    </div>
  );
}